module.exports = __webpack_public_path__ + "img/2fcdf48.jpeg";